import { FormControl, FormControlLabel, FormHelperText, Switch, SwitchProps } from '@mui/material';
import { FieldProps, getFieldProps } from 'shared/_ui/form/utils';

export default function SwitchField(props: FieldProps<SwitchProps>) {
	const { formControlProps, formControlLabelProps, formHelperTextProps, fieldProps, inputProps } =
		getFieldProps<SwitchProps>(props);

	return (
		<FormControl {...formControlProps}>
			<FormControlLabel
				{...formControlLabelProps}
				control={
					<Switch
						{...fieldProps}
						slotProps={{ input: inputProps as NonNullable<SwitchProps['slotProps']>['input'] }}
						checked={!!fieldProps.value}
					/>
				}
			/>
			{formHelperTextProps.children && <FormHelperText {...formHelperTextProps} />}
		</FormControl>
	);
}
